import { createContext, useContext, useState } from "react";
import ConfirmModal from "./ConfirmModal";
import FormModal from "./FormModal";

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  const openModal = (config) => setModal(config);
  const closeModal = () => setModal(null);

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}

      {/* CONFIRM */}
      {modal?.type === "confirm" && (
        <ConfirmModal
          show
          title={modal.title}
          message={modal.message}
          danger={modal.danger}
          confirmText={modal.confirmText}
          onConfirm={() => {
            modal.onConfirm?.();
            closeModal();
          }}
          onCancel={closeModal}
        />
      )}

      {/* FORM */}
      {modal?.type === "form" && (
        <FormModal
          show
          title={modal.title}
          onClose={closeModal}
        >
          {modal.content}
        </FormModal>
      )}
    </ModalContext.Provider>
  );
}

export const useModalContext = () => useContext(ModalContext);
